import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addUserToGroup } from "../../redux/actions/groupActions";
import { toast } from "react-toastify";

function AddGroupMemberControl({
    group,
    subjectUser,
    addUserToGroup,
    onUserAdded
}) {

    useEffect(() => {


    }, [])

    function addUser(e) {
        e.preventDefault();
        addUserToGroup(subjectUser, group.id)
            .then(() => {
                onUserAdded();
                toast.success(`${subjectUser.firstName} ${subjectUser.surname} Added to Group`);
            });
    }

    return (
        <button className="btn btn-info btn-sm" onClick={addUser}>Add</button>
    );
};

AddGroupMemberControl.propTypes = {
    subjectUser: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    addUserToGroup: PropTypes.func.isRequired,
    onUserAdded: PropTypes.func
}

function mapStateToProps(state) {
    return {
    }
}

const mapDispatchToProps = {
    addUserToGroup
}

export default connect(mapStateToProps, mapDispatchToProps)(AddGroupMemberControl);


// WEBPACK FOOTER //
// ./src/components/groups/AddGroupMemberControl.js